import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { ConsoleAuth, createUserManager } from "./auth";
import { loadConfig } from "./config";
import { initI18n } from "./i18n";

async function start() {
  const root = createRoot(document.getElementById("root")!);
  try {
    const [config] = await Promise.all([loadConfig(), initI18n()]);
    const auth = new ConsoleAuth(createUserManager(config));
    root.render(
      <StrictMode>
        <App config={config} auth={auth} />
      </StrictMode>,
    );
  } catch (e) {
    root.render(
      <div role="alert" style={{ padding: 24, fontFamily: "system-ui" }}>
        Failed to start the console: {e instanceof Error ? e.message : String(e)}
      </div>,
    );
  }
}

void start();
